
import { defineComponent } from "@vue/runtime-core";
import "@/styles/global.style.scss";

export default defineComponent({});
